import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import withRouter from "../../withRouter/withRouter";
import { ThunkCretorGetSkills } from "../../../context/reducers/skillsReducer";
import Skills from "./skillsPage";

function SkillsContainer(props) {
    if(props.skills.data == null)
        props.getSkills();

    if (props.skills.data)
        return <Skills {...props.skills} />
}


const mapStateToProps = (state, ownProps) => {
    return {
        skills: state.skills
    }
}

const mapDispatchToProps = (dispatch) => ({
    getSkills: () => {
        dispatch(ThunkCretorGetSkills());
    }
});

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(SkillsContainer);